import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { SessionAuthService } from './session-auth.service';
import { getAccessToken, getDeviceId } from './session-auth.store';
import { debugLog } from './debug-log.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionAuth = inject(SessionAuthService);
  let headers = req.headers.set('X-GFH-Device-Id', getDeviceId());
  const token = getAccessToken();
  const isSessionExchange = req.url.includes('/auth/session');
  if (token && !isSessionExchange) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  return next(req.clone({ headers })).pipe(
    tap({
      error: (error: unknown) => {
        if (error instanceof HttpErrorResponse && error.status === 401 && !isSessionExchange) {
          debugLog.warn('auth', 'API returned 401', { url: req.url, hadAccessToken: !!token, detail: error.error?.detail });
          sessionAuth.markSessionExpired();
        }
      },
    })
  );
};
